import { create } from 'zustand';

type LoadStatus = 'idle' | 'loading' | 'loaded' | 'error';

export interface BootstrapState {
  status: LoadStatus;
  error: string | null;
  loadedTenantId: string | null;
  config: unknown | null;
  planningConfig: unknown | null;
  setLoading: (tenantId: string) => void;
  setLoaded: (payload: { tenantId: string; config: unknown; planningConfig: unknown }) => void;
  setError: (message: string) => void;
  reset: () => void;
}

export const useBootstrapStore = create<BootstrapState>((set) => ({
  status: 'idle',
  error: null,
  loadedTenantId: null,
  config: null,
  planningConfig: null,
  setLoading: (tenantId: string) =>
    set({ status: 'loading', error: null, loadedTenantId: tenantId }),
  setLoaded: ({ tenantId, config, planningConfig }) =>
    set({
      status: 'loaded',
      error: null,
      loadedTenantId: tenantId,
      config,
      planningConfig,
    }),
  setError: (message: string) => set({ status: 'error', error: message }),
  reset: () =>
    set({
      status: 'idle',
      error: null,
      loadedTenantId: null,
      config: null,
      planningConfig: null,
    }),
}));
